export interface FormEvent {
    id: number;
    formId: number;
    status: InternalStatusCodes;
    statusText: string;
    statusEventTimeUtc: Date;
    errorCode: string;
    errorText: string;
    errorTextOverrideDescription?: string;
    errorTraceId: string;
    isStateEvent: boolean;
}

export enum InternalStatusCodes {
    UnknownError = -1,
    Unknown = 0,
    FormReceived = 1,
    ReceiptSend = 2,
    ReceiptReceivedAck = 3,
    CaseCreated = 4,
    WaitingDoctor = 5,
    ReceivedByDoctor = 6,
    DeclinedByDoctor = 7,
    ResponseByDoctor = 8,
    ReceiptBSend = 9,
    ReceiptBReceivedAck = 10,
    ReceiptSendToFstyr = 11,
    ReceiptBSendToFstyr = 12,
    ReceiptReceivedByFstyrAck = 13,
    ReceiptBReceivedByFstyrAck = 14,
    ReceiptNoDoctorSend = 15,
    ReceiptNoDoctorReceivedAck = 16,
    ReceiptNoDoctorSendToFstyr = 17,
    ReceiptNoDoctorReceivedByFstyrAck = 18,
    ReceiptSsnGroup2Send = 19,
    ReceiptSsnGroup2ReceivedAck = 20,
    ReceiptSsnGroup2SendToFstyr = 21,
    ReceiptSsnGroup2ReceivedByFstyrAck = 22,

    Deleted = 99
}
